module.exports = __webpack_public_path__ + "static/media/hydra2.3f5e193a.jpg";